import { render } from "./PPAPApplicabilitySelfInspectionPublish.vue?vue&type=template&id=76e0d132&scoped=true"
import script from "./PPAPApplicabilitySelfInspectionPublish.vue?vue&type=script&lang=js"
export * from "./PPAPApplicabilitySelfInspectionPublish.vue?vue&type=script&lang=js"

import "./PPAPApplicabilitySelfInspectionPublish.vue?vue&type=style&index=0&id=76e0d132&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76e0d132"]])

export default __exports__